import { useState, useEffect } from "react";
import RecentPostBlogs from "@/components/recentpostblog"; // Import the RecentPostBlogs component

// Tabs component to manage tab navigation
const Tabs = ({ tabs = [] }) => {
  const [activeTab, setActiveTab] = useState(tabs.length > 0 ? tabs[0].id : null);

  const handleTabClick = (id) => {
    setActiveTab(id);
  };

  if (tabs.length === 0) {
    return <div>No tabs available</div>;
  }

  return (
    <div className="w-full max-w-7xl mx-auto">
      {/* Tab Titles */}
      <div className="flex border-b border-gray-300">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            className={`py-2 px-4 text-lg font-semibold w-full text-center transition duration-300 ${
              activeTab === tab.id
                ? "border-b-2 border-orange-500 text-orange-500"
                : "text-gray-600 hover:text-orange-500"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="pt-4 min-h-[300px]">
        {tabs.map(
          (tab) =>
            tab.id === activeTab && (
              <div key={tab.id} className="tab-content">
                {tab.content}
              </div>
            )
        )}
      </div>
    </div>
  );
};

// TabExample component that defines the actual tabs
const TabExample = () => {
  const [loading, setLoading] = useState(true); // To simulate loading state

  useEffect(() => {
    // Simulating data fetching with a timeout
    setTimeout(() => {
      setLoading(false);
    }, 2000); // Simulating a 2-second delay
  }, []);

  const tabs = [
    {
      id: "blogs",
      label: "Blogs",
      content: loading ? (
        <div className="text-center text-gray-500">Loading...</div>
      ) : (
        <RecentPostBlogs tag="blogs" /> // Use RecentPostBlogs component for blogs
      ),
    },
    {
      id: "news",
      label: "News",
      content: loading ? (
        <div className="text-center text-gray-500">Loading...</div>
      ) : (
        <RecentPostBlogs tag="news" /> // Use RecentPostBlogs component for news
      ),
    },
  ];

  return (
    <div className="py-8">
      <h2 className="text-3xl font-bold mb-6 text-center">Related Posts</h2>
      <Tabs tabs={tabs} />
    </div>
  );
};

export default TabExample;
